"use client";

import NFLink from "app/components/NFLink/NFLink";
import {getUrl} from "provider/magento/utilities";
import UserIcon from "@heroicons/react/24/outline/UserIcon";
import React from "react";
import {useSession} from "next-auth/react";

const AccountButton = ({store,storeCode,label}) => {

    const {data: session} = useSession();

    return <div className={'ml-3'}>
        <NFLink storeCode={storeCode} href={getUrl(`${store.secure_base_link_url}account`, storeCode)}
            aria-label={label}
            title={label}
            className={'flex'}>
            <span><UserIcon className={'w-5 h-5 mr-1'}/></span>
            <span className={'text-sm hidden xl:block'}>{session && session.user ? <>{session.user.firstname}</> : label}</span>

        </NFLink>
    </div>

}

export default AccountButton;